import { render, staticRenderFns } from "./trainDetail.vue?vue&type=template&id=a9c2f44c&scoped=true"
import script from "./trainDetail.vue?vue&type=script&lang=js"
export * from "./trainDetail.vue?vue&type=script&lang=js"
import style0 from "./trainDetail.vue?vue&type=style&index=0&id=a9c2f44c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c2f44c",
  null
  
)

export default component.exports